module.exports = __webpack_public_path__ + "static/media/days-02.dcccd750.png";